import React from "react";
import Chart from "react-apexcharts";
import { connect } from "react-redux";
import {getChart, changeDate} from "../../redux/actions/mumActions";

import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import Select from "react-select";

const MumChart = ({ theme, mum, getChart, changeDate }) => {

  const annotations = () => {
    let xaxis = [];
    if(mum.chart.chemicals){
      for(let i of mum.chart.chemicals){
        xaxis.push({
          x: i.x,
          strokeDashArray: 0,
          borderColor: "#775DD0",
          label: {
            borderColor: "#775DD0",
            style: {
              color: "#fff",
              background: "#775DD0"
            },
            text: `${i.chemical} - ${i.rate}`
          }
        })
      }
    }
    return xaxis;
  }

  const options = {
    annotations: {
      xaxis: annotations()
    },
    chart: {
      type: "line",
      stacked: false,
      zoom: {
        enabled: true,
        type:'x',
        autoScaleYaxis: true
      },
    },
    grid: {
      padding: {
        left: 0,
        right: 0
      }
    },
    stroke: {
      width: [3,3,3,5,5],
      curve: 'straight'
    },
    plotOptions: {
      bar: {
        columnWidth: '20%'
      }
    },
    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: 'light',
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100]
      }
    },
    markers: {
      size: 0
    },
    xaxis: {
      type: 'datetime',
      categories: `${mum.chart.dates}`
    },
    yaxis: [
      {
        seriesName: 'Upper Curve',
        decimalsInFloat: 2
      },
      {
        seriesName: 'Upper Curve',
        show: false
      },
      {
        seriesName: 'Upper Curve',
        show: false
      },
      {
        opposite: true,
        title: {
          text: 'PH/EC Levels'
        },
        seriesName: 'Ph',
        decimalsInFloat: 2,
        show: false
      },
      {
        seriesName: 'Ph',
        show: false
      }
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(2);
          }
          return y;
        }
      }
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Row>
            <Col sm="3">
            <Select
              defaultValue={mum.chartYears[0]}
              options={mum.chartYears}
              onChange={(e) => changeDate(e)}
              />
            </Col>
            <Col sm="9">
            <Select
              options={mum.chartTitles}
              isSearchable
              onChange={(e) => getChart(e.value)}
              />
            </Col>
          </Row>
        </CardTitle>

      </CardHeader>
      <CardBody style={{padding: 0}}>
        <div className="chart">
          {(mum.chart.graph) &&
          <Chart options={options}  series={mum.chart.graph}
          height="500"
          stacked="false"/>
          }
        </div>
      </CardBody>
    </Card>
  );
};

export default connect(store => ({
  theme: store.theme.currentTheme,
  mum: store.mum
}), {getChart, changeDate})(MumChart);
